import * as ng from 'angular';
import * as _ from 'underscore';

import {ApiHelperService} from '../../shared';
import {User} from './user.model';

export class UsersApi {
   static $inject = ['apiHelper'];

   constructor(private apiHelper:ApiHelperService) { }

   list(params):ng.IPromise<User[]> {
      return this.apiHelper.get(`users?${$.param(params)}`).then((users:any[]) => {
         return _.map(users, u => {
            return new User(u);
         });
      });
   }

   create(user) {
      return this.apiHelper.post('users', user);
   }

   update(user) {
      return this.apiHelper.post(`users/${user.id}`, user);
   }

   del(id) {
      let url = 'users/';

      if (ng.isArray(id)) {
         url = url + 'bulk?ids=' + id.join('&ids=');
      } else {
         url = url + id;
      }

      return this.apiHelper.del(url);
   }

   unlock(id) {
      return this.apiHelper.post(`users/unlock/${id}`, null);
   }
}

ng.module('e360')
   .service('usersApi', UsersApi);
